import {
    GetBasicPrescriberOrdersDocument,
    GetPrescriberOrderDocument,
    PrescriberOrderStatus,
} from '../graphql/generated/graphql';

export const getRefetchQueryForPrescription = (
    prescriberOrderId: string,
    patientId: string
) =>
    [
        {
            query: GetBasicPrescriberOrdersDocument,
            variables: {
                patientId: patientId,
                input: {
                    statusFilter: [
                        PrescriberOrderStatus.New,
                        PrescriberOrderStatus.OnHold,
                    ],
                },
            },
        },
        {
            query: GetPrescriberOrderDocument,
            variables: { prescriberOrderId },
        },
        {
            query: GetBasicPrescriberOrdersDocument,
            variables: {
                patientId,
                input: {
                    statusFilter: [
                        PrescriberOrderStatus.Filled,
                        PrescriberOrderStatus.SentToPharmacy,
                        PrescriberOrderStatus.Cancelled,
                    ],
                },
            },
        },
    ] as const;
